/**
 * 页面加载中占位组件
 * 用于路由懒加载时的 loading 状态
 * 当前隐藏样式，用于测试无 loading 效果
 */
const PageLoading = () => <div style={{ display: 'none' }} />;

export default PageLoading;
